export const mintRegistrationStyles = {
    pendingCard: {
        mb: 3,
        maxWidth: 300,
        backgroundColor: '#F9FAFB'
    },
    avatarContainer: {
        width: 56,
        height: 56,
        backgroundColor: '#D1FAE5'
    },
    scanAvatar: {
        width: 80,
        height: 80,
        backgroundColor: '#EFF6FF',
        color: '#3B82F6',
        mb: 2
    },
    scanAvatarIcon: {
        fontSize: 40
    },
    inputContainer: {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
        maxWidth: 600,
        margin: '0 auto',
        mb: 4
    },
    textFieldRoot: {
        '& .MuiOutlinedInput-root': { height: 40 }
    },
    scanButton: {
        height: 40,
        minWidth: 120,
        width: { xs: '100%', sm: 'auto' },
        textTransform: 'none' as const,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    instructionsList: {
        pl: 2,
        counterReset: 'item',
        '& li': { 
            mb: 1, 
            color: 'text.secondary',
            counterIncrement: 'item'
        },
        '& li::marker': { 
            color: '#155DFC',
            fontSize: '14px',
            fontWeight: 400
        }
    },
    dialogPaper: {
        borderRadius: 2,
        minWidth: 400
    },
    confirmButton: {
        height: 40,
        textTransform: 'none' as const,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};
